module.exports = __webpack_public_path__ + "static/vegan-cola_can-7a444963b3ac1434e52dff611222191e.png";